import { ActionReducer, MetaReducer } from '@ngrx/store';
import { utilLocalStorageReducer } from '@medlogic/shared/utils';
import { ExameActionTypes } from './exame.actions';
import { initialState } from './exame.reducer';

const KEY = 'MEDLOGIC_EXAME_STATE';

// Includes the action types that must be persisted.
const PERSISTED_ACTIONS: string[] = [
  ExameActionTypes.LoadExames
];

export function localStorageReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return utilLocalStorageReducer(reducer, PERSISTED_ACTIONS, KEY, initialState);
}

export const metaReducers: MetaReducer<any>[] = [localStorageReducer];
